import { SvgIcon, useTheme } from "@mui/material";
import type React from "react";
import { useState } from "react";
import { tileTextStyle } from "./style.ts";

const Electronics: React.FC<{ selected: boolean }> = ({ selected }) => {
	const [hovered, setHovered] = useState(false);
	const theme = useTheme();
	const idleBackground = theme.palette.secondary.main;
	const hoverBackground = theme.palette.secondary.light;
	const selectedBackGround = theme.palette.info.main;

	const backGroundColor = selected ? selectedBackGround : hovered ? hoverBackground : idleBackground;
	return (
		<SvgIcon
			onMouseEnter={() => setHovered(true)}
			onMouseLeave={() => setHovered(false)}
			viewBox="0 0 460 259"
			sx={{ width: "100%", height: "auto" }}
		>
			<defs>
				<style>{".cls-2{stroke-miterlimit:10;fill:none;stroke:#fff}"}</style>
			</defs>
			<g id="pozadi-boxu">
				<path
					id="pozadi"
					d="M0 0h460v259H0z"
					style={{
						fill: backGroundColor,
					}}
				/>
			</g>
			<g id="ilustrace">
				<path
					id="Vrstva_2"
					d="M460 237.2H0"
					style={{
						stroke: "#fff",
						fill: "none",
					}}
				/>
				<g
					id="pozemky"
					style={{
						clipPath: "url(#clip-path)",
					}}
				>
					<path
						d="M219.4 221.7h172.5v4.7c0 6-4.6 10.8-10.3 10.8H229.7c-5.7 0-10.3-4.9-10.3-10.8v-4.7Zm172.5 4.7c0 6-4.6 10.8-10.3 10.8H229.7c-5.7 0-10.3-4.9-10.3-10.8m165.6-21V127c0-5.5-4.3-10.1-9.6-10.1H236c-5.3 0-9.6 4.5-9.6 10.1v78.4c0 5.6 4.3 10.1 9.6 10.1h139.4c5.3 0 9.6-4.5 9.6-10.1Zm-79.7-26.6v23M432.2 164.1h-31.8c-3 0-5.5-2.5-5.5-5.5v-66c0-3 2.4-5.5 5.5-5.5h31.8c3 0 5.5 2.5 5.5 5.5v66c0 3-2.4 5.5-5.5 5.5Z"
						className="cls-2"
					/>
					<path
						d="M431.6 159.8h-30.2c-1.3 0-2.4-1.1-2.4-2.5V94.5c0-1.4 1.1-2.5 2-2.5h30.2c1.7 0 2.8 1.1 2.8 2.5v62.8c0 1.4-1.1 2.5-2.4 2.5Z"
						className="cls-2"
					/>
					<circle cx={416.1} cy={154.7} r={3.1} className="cls-2" />
				</g>
			</g>
			<text
				id="texty"
        style={tileTextStyle}
				transform="translate(20 44.289)"
			>
				Elektronika
			</text>
		</SvgIcon>
	);
};

export default Electronics;
